import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import { useSelector } from '../store/utils';
import { WallboxStatus } from '../../../core/src/shared/enums';

type Props = {
  wallboxKey: string;
};

const statusMapping: Record<WallboxStatus, ReactNode> = {
  [WallboxStatus.NotConnected]: (
    <FormattedMessage
      id="wallbox.status.not_connected"
      defaultMessage="Nelze navázat spojení"
    />
  ),
  [WallboxStatus.Off]: (
    <FormattedMessage
      id="wallbox.status.off"
      defaultMessage="Wallbox vypnutý"
    />
  ),
  [WallboxStatus.Normal]: (
    <FormattedMessage id="wallbox.status.normal" defaultMessage="Běžný režim" />
  ),
  [WallboxStatus.CarNotConnected]: (
    <FormattedMessage
      id="wallbox.status.car_not_connected"
      defaultMessage="Auto není připojeno"
    />
  ),
  [WallboxStatus.Ready]: (
    <FormattedMessage
      id="wallbox.status.ready"
      defaultMessage="Připraveno k nabíjení"
    />
  ),
  [WallboxStatus.Charging]: (
    <FormattedMessage id="wallbox.status.charging" defaultMessage="Nabíjení" />
  ),
  [WallboxStatus.ChargingWithVentilation]: (
    <FormattedMessage
      id="wallbox.status.charging_with_ventilation"
      defaultMessage="Nabíjení auta s ventilátorem"
    />
  ),
  [WallboxStatus.Error]: (
    <FormattedMessage
      id="wallbox.status.error"
      defaultMessage="Chyba nabíjení"
    />
  ),
};

export const FormattedWallboxStatusNext = ({ wallboxKey }: Props) => {
  const status = useSelector((s) => {
    const stats = get(s.variables, 'WALLBOX_STATS') || {};
    const statItem = get(stats, wallboxKey);
    return statItem && typeof statItem === 'object' && 'status' in statItem
      ? (statItem.status as WallboxStatus | undefined)
      : undefined;
  });

  if (!status || !(status in statusMapping)) {
    return <>{status || '-'}</>;
  }

  return <>{statusMapping[status]}</>;
};
